export default __webpack_public_path__ + "static/media/img-industrial-operator-selected.993144b4.svg";